import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormService } from '../../services/form.service';

@Component({
	selector: 'app-choose-services',
	templateUrl: './choose-services.component.html',
	styleUrls: ['./choose-services.component.scss']
})
export class ChooseServicesComponent implements OnInit {
	public formGroupName: string = 'choose_services';
	public chooseServicesForm!: UntypedFormGroup;

	constructor(public formService: FormService) {}

	ngOnInit(): void {
		this.chooseServicesForm = this.formService.thirdPartyForm.get(this.formGroupName) as UntypedFormGroup;
	}

	onSubmit(): void {
		console.log( 'submitting Third party form group' );

		this.formService.submitThirdPartyFormGroup(this.chooseServicesForm);
	}
}
